class TC_SegmentIntegration {
    constructor (channelsInstance) {
        this.channels = channelsInstance;
        this.debugMode = false;
        this.isSafariDesktop = window.safari !== undefined;
    }

    init () {
        this.API = {
            userID: 'calmchristian-' + this.channels.user.id,
            userStatus: this.channels.user.isVip ? 'PAYING' : 'FREE',
            UUID: TC_generateUUID(true, 'Segment')
        };

        this.heartbeatCallbacks = {
            channel1: null
        };

        this.prepareCachedData();
    }

    prepareCachedData () {
        this.cachedData = {
            channelCategoryIDs: {},
            channelCategoryNames: {},
            genreNames: {},
            genreCategoryIDs: {},
        };

        for (let i = 0; i < this.channels.remoteData.channels.length; i++) {
            let channelID = this.channels.remoteData.channels[i].id;
            let categoryID = this.channels.remoteData.channels[i].category;
            this.cachedData.channelCategoryIDs[channelID] = categoryID;
        }

        for (let i = 0; i < this.channels.remoteData.categories.length; i++) {
            let categoryID = this.channels.remoteData.categories[i].id;
            let categoryName = this.channels.remoteData.categories[i].title;
            this.cachedData.channelCategoryNames[categoryID] = categoryName;
        }

        let genres = this.channels.remoteData.rows.filter(row => row.kind === 'genre');

        for (let i = 0; i < genres.length; i++) {
            let genreID = genres[i].id;
            let genreName = genres[i].title;
            this.cachedData.genreNames[genreID] = genreName;
        }

        for (let i = 0; i < this.channels.remoteData.categories.length; i++) {
            let categoryID = this.channels.remoteData.categories[i].id;

            for (let j = 0; j < genres.length; j++) {
                if (genres[j].categories.indexOf(categoryID) > -1) {
                    this.cachedData.genreCategoryIDs[categoryID] = genres[j].id;
                    break;
                }
            }
        }
    }

    // initialized in TC_Channels constructor
    initEvents () {
        this.channels.playerInstance.audioChannels['channel1'].element.addEventListener('stalled', () => { 
            // Ignore event on safari desktop as it sends it very randomly
            if (this.isSafariDesktop) {
                return;
            }

            this.sendApiEvent('Audio Playback Completed', 1, 'stalled');
            this.channels.playerInstance.stalledChannels['channel1'] = true; 
            $(document).trigger('playingStateChanged', [false]);
            this.channels.playerInstance.UI.buttons.playIconPause.addClass('is-hidden');
            this.channels.playerInstance.UI.buttons.playIconPlay.removeClass('is-hidden');

            $(this.channels.playerInstance.audioChannels['channel1'].element).one('playing', () => {
                this.channels.playerInstance.playing = true;
                $(document).trigger('playingStateChanged', [true]);
                this.channels.playerInstance.UI.buttons.playIconPause.removeClass('is-hidden');
                this.channels.playerInstance.UI.buttons.playIconPlay.addClass('is-hidden');
                console.log('Channel 1 is playing again');
                this.sendApiEvent('Audio Playback Started', 1, 'stalled');
            });
        }, false);

        window.addEventListener('beforeunload', e => {
            if (this.channels.playerInstance.playing) {
                this.sendApiEvent('Audio Playback Completed', 1, 'unload');
            }
        });
    }

    sendApiEvent (eventName, channelIndex, eventSource) {
        // avoid duplicate calls of playing events on stalled channels
        if (
            !this.channels.playerInstance.stalledChannels['channel' + channelIndex] && 
            eventSource === 'stalled' && 
            eventName === 'Audio Playback Started'
        ) {
            return;
        }

        if (this.channels.playerInstance.stalledChannels['channel' + channelIndex]) {
            this.channels.playerInstance.stalledChannels['channel' + channelIndex] = false;

            if (eventSource !== 'stalled') {
                return;
            }
        }

        let channelID = this.getChannelID();
        let ipData = this.getIpData(); 
        let channel = this.getChannelData(channelID);
        let soundLevel = this.getChannelVolume(channelIndex);
        let userStatus = this.API.userStatus;

        // can be overrided in the account-type-checker.js
        if (this.channels.playerInstance.stoppedChannelsUserStatus) {
            userStatus = this.channels.playerInstance.stoppedChannelsUserStatus;
        }

        let streamBitrate = this.getBitrate(userStatus);

        // can be overrided in player-bitrate.js
        if (this.channels.playerInstance.stoppedChannelsBitrate) {
            streamBitrate = this.channels.playerInstance.stoppedChannelsBitrate;
        }

        let objectToSend = {
            calm_member_status: userStatus,                         // <<type: string, required: true>>
            channel_id: (channelID).toString(),                     // <<type: string, required: true>>

            ip_city: ipData.city,                                   // <<type: string, required: false>>
            ip_country: ipData.country,                             // <<type: string, required: true>>
            ip_region: ipData.region,                               // <<type: string, required: false>>

            is_background_track: false,                             // <<type: boolean, required: false>>
            is_external_content: false,                             // <<type: boolean, required: false>>

            main_channel_category_id: channel.categoryID,       // <<type: integer, required: false>>
            main_channel_category_name: channel.categoryName,   // <<type: string, required: false>>
            main_channel_genre_id: channel.genreID,             // <<type: integer, required: false>>
            main_channel_genre_name: channel.genreName,         // <<type: string, required: false>>

            session_id: this.API.UUID                               // <<type: string, required: true>>                                   
        };

        if (streamBitrate !== false) {
            objectToSend.audio_quality = streamBitrate;             // <<type: integer, required: false>>
        }

        if (soundLevel !== false) {
            objectToSend.sound = soundLevel;                        // <<type: integer, required: false>>
        }

        if (this.debugMode) {
            console.log('📶 [EVENT - ' + eventSource + '] ' + eventName, JSON.parse(JSON.stringify(objectToSend)));
        }

        if (window.analytics) {
            window.analytics.track(eventName, JSON.parse(JSON.stringify(objectToSend)), { 'userId': (this.API.userID).toString() });
        }

        if (eventName === 'Audio Playback Started') {
            clearInterval(this.heartbeatCallbacks['channel' + channelIndex]);

            this.heartbeatCallbacks['channel' + channelIndex] = setInterval(() => {
                this.sendApiEvent('Audio Playback Playing', channelIndex, 'heartbeat');
            }, 10 * 1000);
        } else if (eventName === 'Audio Playback Completed') {
            clearInterval(this.heartbeatCallbacks['channel' + channelIndex]);
        }
    }

    getBitrate (userStatus) {
        if (userStatus === 'FREE') {
            return 128;
        }

        return parseInt(this.channels.playerInstance.bitrateMode, 10);
    }

    getChannelID () {
        return this.channels.playerInstance.currentChannel.id;
    }

    getChannelVolume (channelIndex) {
        if (this.channels.playerInstance.audioChannels['channel' + channelIndex]) {
            let volume = this.channels.playerInstance.audioChannels['channel' + channelIndex].volume * 100;
            volume = parseInt(volume, 10);
            return volume;
        }

        return false;
    }

    getIpData () {
        return { 
            city: this.channels.user.geo.ip_city, 
            country: this.channels.user.geo.ip_country, 
            region: this.channels.user.geo.ip_region
        };
    }

    getChannelData (channelID) {
        let categoryID = this.getChannelCategoryID(channelID);
        let genreID = this.getChannelGenreID(categoryID);

        return { 
            categoryID: categoryID, 
            categoryName: this.getChannelCategoryName(categoryID), 
            genreID: genreID, 
            genreName: this.getChannelGenreName(genreID) 
        };
    }

    getChannelCategoryID (channelID) {
        return this.cachedData.channelCategoryIDs[channelID];
    }

    getChannelCategoryName (categoryID) {
        return this.cachedData.channelCategoryNames[categoryID];
    }

    getChannelGenreID (categoryID) {
        return this.cachedData.genreCategoryIDs[categoryID]
    }

    getChannelGenreName (genreID) {
        return this.cachedData.genreNames[genreID];
    }
}